import { SalePriceScheduleSlot } from './sale-price-schedule-slot';
import { SalePriceScheduleType } from './sale-price-schedule-type';

export class SalePriceSchedule {
  id: number;
  name: string;
  sequence: number;
  startDate: string;
  endDate: string;
  salePriceScheduleSlots: SalePriceScheduleSlot[] = [];
  salePriceScheduleType: SalePriceScheduleType = null;

  constructor() { }

  static arrayFromJSON(json: string): SalePriceSchedule[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: SalePriceSchedule[] = [];
    for (const item of values) {
      result.push(SalePriceSchedule.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): SalePriceSchedule {
    if (object === null || object === undefined) {
      return null;
    }
    const salePriceSchedule = new SalePriceSchedule();
    salePriceSchedule.id = object.id;
    salePriceSchedule.name = object.name;
    salePriceSchedule.startDate = object.startDate;
    salePriceSchedule.endDate = object.endDate;
    salePriceSchedule.salePriceScheduleSlots = object.salePriceScheduleSlots ? object.salePriceScheduleSlots.map(x => SalePriceScheduleSlot.createFromAny(x)) : null;
    salePriceSchedule.salePriceScheduleType = object.salePriceScheduleType ? SalePriceScheduleType.createFromAny(object.salePriceScheduleType) : null;

    return salePriceSchedule;
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      sequence: this.sequence,
      startDate: this.startDate,
      endDate: this.endDate,
      salePriceScheduleSlots: this.salePriceScheduleSlots,
      salePriceScheduleType: this.salePriceScheduleType
    };
  }
}
